import { render, staticRenderFns } from "./Sunburst.vue?vue&type=template&id=166b7e6d&scoped=true"
import script from "./Sunburst.vue?vue&type=script&lang=js"
export * from "./Sunburst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b7e6d",
  null
  
)

export default component.exports